// Configuração padrão para impressora térmica
const CONFIG_PADRAO = {
    larguraPapel: 80,
    tamanhofonte: 'normal',
    cortarPapel: true,
    gaveta: false
};
// Classe para formatação de impressão térmica
export class ImpressoraTermica {
    constructor(config = {}) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "linhasImpressao", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.config = { ...CONFIG_PADRAO, ...config };
    }
    // Adicionar linha centralizada
    adicionarLinhaCentralizada(texto, tamanho = 'normal') {
        const larguraMaxima = this.config.larguraPapel === 80 ? 48 : 32;
        // Se o texto for maior que a largura, quebrar em linhas
        if (texto.length > larguraMaxima) {
            const linhas = this.quebrarTexto(texto, larguraMaxima);
            linhas.forEach(linha => {
                const espacos = Math.max(0, Math.floor((larguraMaxima - linha.length) / 2));
                this.linhasImpressao.push(' '.repeat(espacos) + linha);
            });
        }
        else {
            const espacos = Math.max(0, Math.floor((larguraMaxima - texto.length) / 2));
            this.linhasImpressao.push(' '.repeat(espacos) + texto);
        }
    }
    // Adicionar linha normal
    adicionarLinha(texto) {
        const larguraMaxima = this.config.larguraPapel === 80 ? 48 : 32;
        if (texto.length > larguraMaxima) {
            // Quebrar linha se necessário
            const linhas = this.quebrarTexto(texto, larguraMaxima);
            linhas.forEach(linha => this.linhasImpressao.push(linha));
        }
        else {
            this.linhasImpressao.push(texto);
        }
    }
    // Quebrar texto em linhas
    quebrarTexto(texto, largura) {
        const palavras = texto.split(' ');
        const linhas = [];
        let linhaAtual = '';
        for (const palavra of palavras) {
            if (linhaAtual.length + palavra.length + 1 <= largura) {
                linhaAtual += (linhaAtual ? ' ' : '') + palavra;
            }
            else {
                if (linhaAtual)
                    linhas.push(linhaAtual);
                linhaAtual = palavra;
            }
        }
        if (linhaAtual)
            linhas.push(linhaAtual);
        return linhas;
    }
    // Adicionar linha de separação
    adicionarSeparador(caractere = '-') {
        const largura = this.config.larguraPapel === 80 ? 48 : 32;
        this.linhasImpressao.push(caractere.repeat(largura));
    }
    // Adicionar linha com duas colunas
    adicionarDuasColunas(esquerda, direita) {
        // Reduzir largura para evitar corte na borda direita
        const largura = this.config.larguraPapel === 80 ? 44 : 30;
        const espacos = largura - esquerda.length - direita.length;
        if (espacos >= 1) {
            this.linhasImpressao.push(esquerda + ' '.repeat(espacos) + direita);
        }
        else {
            // Se não couber, quebrar em duas linhas
            this.adicionarLinha(esquerda);
            this.adicionarLinha(' '.repeat(Math.max(0, largura - direita.length)) + direita);
        }
    }
    // Método para gerar cabeçalho padrão da empresa
    adicionarCabecalhoEmpresa(dados) {
        // Adicionar espaço antes do nome da empresa
        this.linhasImpressao.push('');
        // Nome da empresa em maiúsculas e negrito (simulado com underline)
        const nomeEmpresa = dados.dadosEmpresa.nome.toUpperCase();
        this.adicionarLinhaCentralizada(nomeEmpresa, 'grande');
        // Linha de underline para simular negrito
        const larguraMaxima = this.config.larguraPapel === 80 ? 48 : 32;
        const comprimentoUnderline = Math.min(nomeEmpresa.length, larguraMaxima);
        const espacos = Math.max(0, Math.floor((larguraMaxima - comprimentoUnderline) / 2));
        this.linhasImpressao.push(' '.repeat(espacos) + '='.repeat(comprimentoUnderline));
        // Adicionar espaço após o nome
        this.linhasImpressao.push('');
        if (dados.dadosEmpresa.nif) {
            this.adicionarLinhaCentralizada(`NIF: ${dados.dadosEmpresa.nif}`);
        }
        if (dados.dadosEmpresa.endereco) {
            this.adicionarLinhaCentralizada(dados.dadosEmpresa.endereco);
        }
        if (dados.dadosEmpresa.telefone) {
            this.adicionarLinhaCentralizada(`Tel: ${dados.dadosEmpresa.telefone}`);
        }
        if (dados.dadosEmpresa.email) {
            this.adicionarLinhaCentralizada(`Email: ${dados.dadosEmpresa.email}`);
        }
        if (dados.dadosEmpresa.website) {
            this.adicionarLinhaCentralizada(dados.dadosEmpresa.website);
        }
    }
    // Método para gerar seção de dados do cliente
    adicionarDadosCliente(dados) {
        this.adicionarLinha('DADOS DO CLIENTE');
        this.adicionarSeparador();
        this.adicionarLinha(`Nome: ${dados.dadosCliente.nome}`);
        if (dados.dadosCliente.telefone) {
            this.adicionarLinha(`Tel: ${dados.dadosCliente.telefone}`);
        }
        if (dados.dadosCliente.email) {
            this.adicionarLinha(`Email: ${dados.dadosCliente.email}`);
        }
        if (dados.dadosCliente.documento) {
            this.adicionarLinha(`Doc: ${dados.dadosCliente.documento}`);
        }
        this.adicionarSeparador();
    }
    // Método para gerar seção de dados do equipamento
    adicionarDadosEquipamento(dados, formato = 'completo') {
        if (!dados.dadosEquipamento)
            return;
        this.adicionarLinha('DADOS DO EQUIPAMENTO');
        this.adicionarSeparador();
        if (formato === 'resumido') {
            // Formato resumido para orçamentos
            if (dados.dadosEquipamento.tipo) {
                this.adicionarLinha(`Tipo: ${dados.dadosEquipamento.tipo}`);
            }
            if (dados.dadosEquipamento.marca && dados.dadosEquipamento.modelo) {
                this.adicionarLinha(`${dados.dadosEquipamento.marca} ${dados.dadosEquipamento.modelo}`);
            }
            if (dados.dadosEquipamento.numeroSerie) {
                this.adicionarLinha(`N. Serie: ${dados.dadosEquipamento.numeroSerie}`);
            }
        }
        else {
            // Formato completo para OS
            if (dados.dadosEquipamento.tipo) {
                this.adicionarLinha(`Tipo: ${dados.dadosEquipamento.tipo}`);
            }
            if (dados.dadosEquipamento.marca) {
                this.adicionarLinha(`Marca: ${dados.dadosEquipamento.marca}`);
            }
            if (dados.dadosEquipamento.modelo) {
                this.adicionarLinha(`Modelo: ${dados.dadosEquipamento.modelo}`);
            }
            if (dados.dadosEquipamento.numeroSerie) {
                this.adicionarLinha(`N. Serie: ${dados.dadosEquipamento.numeroSerie}`);
            }
            if (dados.dadosEquipamento.imei) {
                this.adicionarLinha(`IMEI: ${dados.dadosEquipamento.imei}`);
            }
            if (dados.dadosEquipamento.cor) {
                this.adicionarLinha(`Cor: ${dados.dadosEquipamento.cor}`);
            }
            if (dados.dadosEquipamento.estadoFisico) {
                this.adicionarLinha(`Estado: ${dados.dadosEquipamento.estadoFisico}`);
            }
            if (dados.dadosEquipamento.acessorios) {
                this.adicionarLinha(`Acessorios: ${dados.dadosEquipamento.acessorios}`);
            }
            if (dados.dadosEquipamento.senhaDesbloqueio) {
                this.adicionarLinha(`Senha: ${dados.dadosEquipamento.senhaDesbloqueio}`);
            }
            if (dados.dadosEquipamento.observacoes) {
                this.adicionarLinha(`Obs: ${dados.dadosEquipamento.observacoes}`);
            }
        }
        this.adicionarSeparador();
    }
    // Gerar cupom de abertura de OS
    gerarAberturaOS(dados) {
        this.linhasImpressao = [];
        // Cabeçalho padrão da empresa
        this.adicionarCabecalhoEmpresa(dados);
        this.adicionarSeparador('=');
        this.adicionarLinhaCentralizada('ORDEM DE SERVICO - ABERTURA', 'grande');
        this.adicionarSeparador('=');
        // Dados do documento
        this.adicionarDuasColunas('OS Nº:', dados.numeroDocumento);
        this.adicionarDuasColunas('Data:', dados.dataHora);
        this.adicionarSeparador();
        // Dados do cliente padronizados
        this.adicionarDadosCliente(dados);
        // Dados do equipamento padronizados
        if (dados.dadosEquipamento) {
            this.adicionarDadosEquipamento(dados, 'completo');
        }
        // Problema relatado
        if (dados.observacoes) {
            this.adicionarLinha('PROBLEMA RELATADO:');
            this.adicionarSeparador();
            this.adicionarLinha(dados.observacoes);
            this.adicionarSeparador();
        }
        // Rodapé
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('EQUIPAMENTO RECEBIDO PARA');
        this.adicionarLinhaCentralizada('ANALISE E ORCAMENTO');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('PRAZO DE ORCAMENTO: 48H');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('_________________________');
        this.adicionarLinhaCentralizada('ASSINATURA DO CLIENTE');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('GUARDE ESTE COMPROVANTE');
        return this.finalizarImpressao();
    }
    // Gerar cupom de orçamento
    gerarOrcamento(dados) {
        this.linhasImpressao = [];
        // Cabeçalho padrão da empresa
        this.adicionarCabecalhoEmpresa(dados);
        this.adicionarSeparador('=');
        this.adicionarLinhaCentralizada('ORCAMENTO', 'grande');
        this.adicionarSeparador('=');
        // Dados do documento
        this.adicionarDuasColunas('Orcamento Nº:', dados.numeroDocumento);
        this.adicionarDuasColunas('Data:', dados.dataHora);
        this.adicionarSeparador();
        // Dados do cliente padronizados
        this.adicionarDadosCliente(dados);
        // Dados do equipamento padronizados
        if (dados.dadosEquipamento) {
            this.adicionarDadosEquipamento(dados, 'resumido');
        }
        // Itens/Serviços
        if (dados.itens && dados.itens.length > 0) {
            this.adicionarLinha('ITENS/SERVICOS:');
            this.adicionarSeparador();
            dados.itens.forEach((item, index) => {
                this.adicionarLinha(`${index + 1}. ${item.descricao}`);
                if (item.quantidade && item.valorUnitario) {
                    this.adicionarDuasColunas(`   ${item.quantidade}x €${item.valorUnitario.toFixed(2)}`, `€${item.valorTotal.toFixed(2)}`);
                }
                else {
                    this.adicionarDuasColunas('', `€${item.valorTotal.toFixed(2)}`);
                }
                this.adicionarLinha('');
            });
        }
        this.adicionarSeparador('=');
        if (dados.valorTotal) {
            this.adicionarDuasColunas('TOTAL GERAL:', `€${dados.valorTotal.toFixed(2)}`);
        }
        this.adicionarSeparador('=');
        // Observações
        if (dados.observacoes) {
            this.adicionarLinha('');
            this.adicionarLinha('OBSERVACOES:');
            this.adicionarLinha(dados.observacoes);
        }
        // Termos e condições
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('VALIDO POR 30 DIAS');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('APROVACAO:');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('_________________________');
        this.adicionarLinhaCentralizada('ASSINATURA DO CLIENTE');
        return this.finalizarImpressao();
    }
    // Gerar cupom de fechamento de OS
    gerarFechamentoOS(dados) {
        this.linhasImpressao = [];
        // Cabeçalho padrão da empresa
        this.adicionarCabecalhoEmpresa(dados);
        this.adicionarSeparador('=');
        this.adicionarLinhaCentralizada('ORDEM DE SERVICO - ENTREGA', 'grande');
        this.adicionarSeparador('=');
        // Dados do documento
        this.adicionarDuasColunas('OS Nº:', dados.numeroDocumento);
        this.adicionarDuasColunas('Data:', dados.dataHora);
        this.adicionarSeparador();
        // Dados do cliente padronizados
        this.adicionarDadosCliente(dados);
        // Dados do equipamento padronizados
        if (dados.dadosEquipamento) {
            this.adicionarDadosEquipamento(dados, 'completo');
        }
        // Serviços realizados
        if (dados.itens && dados.itens.length > 0) {
            this.adicionarLinha('SERVICOS REALIZADOS:');
            this.adicionarSeparador();
            dados.itens.forEach((item, index) => {
                this.adicionarLinha(`${index + 1}. ${item.descricao}`);
                if (item.quantidade && item.valorUnitario) {
                    this.adicionarDuasColunas(`   ${item.quantidade}x €${item.valorUnitario.toFixed(2)}`, `€${item.valorTotal.toFixed(2)}`);
                }
                else {
                    this.adicionarDuasColunas('', `€${item.valorTotal.toFixed(2)}`);
                }
                this.adicionarLinha('');
            });
        }
        // Total
        this.adicionarSeparador('=');
        if (dados.valorTotal) {
            this.adicionarDuasColunas('TOTAL PAGO:', `€${dados.valorTotal.toFixed(2)}`);
        }
        this.adicionarSeparador('=');
        // Observações finais
        if (dados.observacoes) {
            this.adicionarLinha('');
            this.adicionarLinha('OBSERVACOES FINAIS:');
            this.adicionarLinha(dados.observacoes);
            this.adicionarSeparador();
        }
        // Termos de garantia
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('EQUIPAMENTO TESTADO E');
        this.adicionarLinhaCentralizada('ENTREGUE EM PERFEITO ESTADO');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('GARANTIA: 90 DIAS');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('OBRIGADO PELA CONFIANCA!');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('_________________________');
        this.adicionarLinhaCentralizada('ASSINATURA DO CLIENTE');
        return this.finalizarImpressao();
    }
    // Gerar recibo
    gerarRecibo(dados) {
        this.linhasImpressao = [];
        // Cabeçalho padrão da empresa
        this.adicionarCabecalhoEmpresa(dados);
        this.adicionarSeparador('=');
        this.adicionarLinhaCentralizada('RECIBO', 'grande');
        this.adicionarSeparador('=');
        // Dados do documento
        this.adicionarDuasColunas('Recibo Nº:', dados.numeroDocumento);
        this.adicionarDuasColunas('Data:', dados.dataHora);
        this.adicionarSeparador();
        // Dados do cliente padronizados
        this.adicionarDadosCliente(dados);
        // Dados do equipamento (se houver)
        if (dados.dadosEquipamento) {
            this.adicionarDadosEquipamento(dados, 'resumido');
        }
        // Serviços/Itens
        if (dados.itens && dados.itens.length > 0) {
            this.adicionarLinha('SERVICOS/PRODUTOS:');
            this.adicionarSeparador();
            dados.itens.forEach((item, index) => {
                this.adicionarLinha(`${index + 1}. ${item.descricao}`);
                if (item.quantidade && item.valorUnitario) {
                    this.adicionarDuasColunas(`   ${item.quantidade}x €${item.valorUnitario.toFixed(2)}`, `€${item.valorTotal.toFixed(2)}`);
                }
                else {
                    this.adicionarDuasColunas('', `€${item.valorTotal.toFixed(2)}`);
                }
                this.adicionarLinha('');
            });
        }
        // Valor total
        this.adicionarSeparador('=');
        if (dados.valorTotal) {
            this.adicionarDuasColunas('TOTAL PAGO:', `€${dados.valorTotal.toFixed(2)}`);
        }
        this.adicionarSeparador('=');
        // Observações
        if (dados.observacoes) {
            this.adicionarLinha('');
            this.adicionarLinha('OBSERVACOES:');
            this.adicionarLinha(dados.observacoes);
        }
        // Rodapé
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('OBRIGADO PELA PREFERENCIA!');
        this.adicionarLinha('');
        this.adicionarLinhaCentralizada('_________________________');
        this.adicionarLinhaCentralizada('ASSINATURA / CARIMBO');
        return this.finalizarImpressao();
    }
    // Finalizar impressão com comandos de controle
    finalizarImpressao() {
        // Adicionar quebras de linha finais
        this.linhasImpressao.push('');
        this.linhasImpressao.push('');
        this.linhasImpressao.push('');
        // Comandos de controle da impressora (ESC/POS)
        let resultado = this.linhasImpressao.join('\n');
        if (this.config.cortarPapel) {
            // Comando para cortar papel (ESC i)
            resultado += '\x1B\x69';
        }
        if (this.config.gaveta) {
            // Comando para abrir gaveta (ESC p)
            resultado += '\x1B\x70\x00\x19\xFA';
        }
        return resultado;
    }
    // Método principal para gerar cupom
    gerarCupom(dados) {
        switch (dados.tipo) {
            case 'ORDEM_SERVICO_ABERTURA':
                return this.gerarAberturaOS(dados);
            case 'ORDEM_SERVICO_FECHAMENTO':
                return this.gerarFechamentoOS(dados);
            case 'ORCAMENTO':
                return this.gerarOrcamento(dados);
            case 'RECIBO':
                return this.gerarRecibo(dados);
            default:
                throw new Error(`Tipo de documento não suportado: ${dados.tipo}`);
        }
    }
}
// Função utilitária para imprimir
export const imprimirCupom = async (dados, configuracao) => {
    const impressora = new ImpressoraTermica(configuracao);
    const cupom = impressora.gerarCupom(dados);
    // Tentar imprimir usando a API de impressão do navegador
    try {
        // Criar uma janela oculta para impressão
        const janelaImpressao = window.open('', '_blank', 'width=300,height=400');
        if (!janelaImpressao) {
            throw new Error('Não foi possível abrir janela de impressão');
        }
        janelaImpressao.document.write(`
      <html>
        <head>
          <title>Cupom - ${dados.numeroDocumento}</title>
          <style>
            body {
              font-family: 'Courier New', monospace;
              font-size: 12px;
              margin: 0;
              padding: 10px;
              white-space: pre;
              background: white;
            }
            @media print {
              body { margin: 0; padding: 5px; }
              @page { margin: 0; }
            }
          </style>
        </head>
        <body>${cupom}</body>
      </html>
    `);
        janelaImpressao.document.close();
        janelaImpressao.focus();
        // Aguardar carregamento e imprimir
        setTimeout(() => {
            janelaImpressao.print();
            janelaImpressao.close();
        }, 500);
    }
    catch (error) {
        console.error('Erro ao imprimir:', error);
        // Fallback: mostrar em modal ou download
        const blob = new Blob([cupom], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `cupom-${dados.numeroDocumento}.txt`;
        link.click();
        URL.revokeObjectURL(url);
    }
};
// Função para preview do cupom
export const previewCupom = (dados, configuracao) => {
    const impressora = new ImpressoraTermica(configuracao);
    return impressora.gerarCupom(dados);
};
